import { FC, lazy } from 'react';
import { PageSpinner } from 'src/components/spinner-container';
import { useTsos } from 'src/pages/market-information/players/operators/use-tsos';
import { useOrganisationService } from 'src/pages/settings/organisation/use-organisation-service';
import { useMyUserDetails } from 'src/pages/settings/profile/use-my-user-details';

const Page = lazy(() => import('./page'));

export const Dashboard: FC = () => {
  const tsos = useTsos({ randomOrder: true });
  const organisationService = useOrganisationService();

  const myUserDetails = useMyUserDetails({ organisationService });

  if (!tsos.response || !myUserDetails.response) return <PageSpinner />;

  return <Page tsos={tsos} myUserDetails={myUserDetails} />;
};
